import { Uniform } from './Uniform';

export class UniformInt extends Uniform {

    loadInt(value: number){
        if(this.location){
            this.gl.uniform1i(this.location, value);
        }
    }
}